import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Typography } from '@coolblue-development/freddy';
import { freddyTheme, Modal, ModalBody, useMediaQuery, VideoContainer, } from '@coolblue-development/freddy';
import selectVideoExplanationTrigger from '@coolblue-development/ga4-events/triggers/ServiceAccessoryOverlays/selectVideoExplanationTrigger';
import { PlayCircled } from '@coolblue-development/icons';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useFreddyTranslations } from '@coolblue-development/next-design-system-utils/client';
import { useState } from 'react';
export const VideoOverlay = ({ videoId, entry, title }) => {
    const [isOpen, setIsOpen] = useState(false);
    const { trackEvent } = useAnalytics();
    const modalTranslations = useFreddyTranslations('modal');
    const query = freddyTheme.breakpoint.maxWidth('md');
    const matchesMediumBreakpoint = useMediaQuery(query);
    return (_jsxs(_Fragment, { children: [_jsxs(Box, { onClick: () => {
                    setIsOpen(true);
                    trackEvent(selectVideoExplanationTrigger({
                        subject_id: videoId,
                    }));
                }, sx: theme => ({
                    display: 'flex',
                    alignItems: 'center',
                    color: theme.color.font.interactiveBase,
                    cursor: 'pointer',
                }), children: [_jsx(PlayCircled, { size: 16 }), _jsx(Typography, { marginLeft: '0.8rem', variant: 'body', color: "interactiveBase", children: entry })] }), _jsx(Modal, { open: isOpen, onClose: () => setIsOpen(false), title: title, size: "large", placement: matchesMediumBreakpoint ? 'bottom' : 'center', translations: modalTranslations, body: _jsx(ModalBody, { children: _jsx(VideoContainer, { videoId: videoId, title: title }) }) })] }));
};
//# sourceMappingURL=VideoOverlay.js.map